module.exports = __webpack_public_path__ + "img/main-gallery4.bd5be01b.jpg";